import { computed } from 'vue';
import { useRouter } from 'vue-router';

import useViewState from '@/composables/useViewState';
import { confirmReadingSpecialOffer } from '@/contexts/billingContext/services';
import { showErrorNotification } from '@/domains/showErrorNotification';
import { useTenantsStore } from '@/stores/tenants';

export const useConfirmReadingSpecialOffer = () => {
  const tenantsStore = useTenantsStore();
  const router = useRouter();

  const {
    isLoading,
    setViewStateAs,
  } = useViewState();

  const activeSubscription = computed(() => tenantsStore.getActiveSubscription);

  const specialOffer = computed(() => activeSubscription.value?.specialOffer);

  const handleSpecialOfferReadingConfirm = () => {
    if (!!specialOffer.value?.confirmedAt || isLoading.value) return;

    setViewStateAs.loading();

    confirmReadingSpecialOffer()
      .then(() => {
        tenantsStore.loadTenantInfo()
          .then(() => router.push('/tenant/finance'))
          .catch(showErrorNotification);
      })
      .catch(showErrorNotification)
      .finally(setViewStateAs.done);
  };

  return {
    isLoading,
    specialOffer,

    handleSpecialOfferReadingConfirm,
  };
};
